import { memo, useCallback } from 'react';

import { WorkspaceAgentQuickReplyChip } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/chips/WorkspaceAgentQuickReplyChip';
import { type WorkspaceAgentResultQuickReply } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/messages/types';

export type WorkspaceAgentResultMessageQuickReplyProps = {
  'data-testid'?: string;
  /** Required: a suggested prompt that cannot be taken has no reason to be offered. */
  onSelect: (id: string) => void;
  quickReply: WorkspaceAgentResultQuickReply;
};

/**
 * One suggested next prompt. Exists so the message's `onSelect` can be bound to a reply id once per
 * chip rather than rebuilt on every render of the message.
 */
export const WorkspaceAgentResultMessageQuickReply = memo(
  ({ 'data-testid': testId, onSelect, quickReply }: WorkspaceAgentResultMessageQuickReplyProps) => {
    const handleSelect = useCallback(() => onSelect(quickReply.id), [onSelect, quickReply.id]);

    return (
      <WorkspaceAgentQuickReplyChip
        data-testid={testId}
        icon={quickReply.icon}
        label={quickReply.label}
        onSelect={handleSelect}
      />
    );
  },
);

WorkspaceAgentResultMessageQuickReply.displayName = 'WorkspaceAgentResultMessageQuickReply';
